module.exports = __webpack_public_path__ + "img/5.9f53f4c9.jpg";